import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus, FaEye,FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate ,useParams} from 'react-router-dom';
import { getAllMainSubProduct, subproductDeletion } from "./subproductAction";
import $ from 'jquery';
import moment from 'moment'
import Swal from 'sweetalert2'
import { Tooltip } from "@mui/material";
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button1 from '@mui/material/Button';

const SubProductListId = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {id} = useParams();
    const {name} = useParams();
    const {name2} = useParams();
    const firstUpdate = useRef(true);
    const { subproducts2, pisLoading, pdstatus, pdmessage } = useSelector((state) => state.subproductList);
    
    console.log("subproducts2",subproducts2)
    //console.log(suppliers);

    useEffect(() => {
        dispatch(getSRolePermission());
        
    }, []);

    const onPagepath = () => {
        navigate('/createSubProduct');
    }
  
    const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
        (state) => state.rolePermissionList
      );

      const filteredPermissions = combinedrolepermissiondetails.filter(
        (item) => item.label === "Add Sub Product"
      );
      let menu_view=0;
      let menu_add = 0;
      let menu_edit = 0;
      let menu_delete = 0;
      
      if (filteredPermissions.length > 0) {
        const permission = filteredPermissions[0];
        menu_view = permission.menu_view;
        menu_add = permission.menu_add;
        menu_edit = permission.menu_edit;
        menu_delete = permission.menu_delete;
      }
   
    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            dispatch(getAllMainSubProduct());
           
        }

        // console.log("componentDidUpdateFunction");
    },[pdmessage]);
    useEffect(() => {
        dispatch(getAllMainSubProduct());
      
    }, [pdmessage]);

    if (pisLoading) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl justify-content-center">
                    <h2>Loading.....</h2>
                    {pisLoading && <Spinner variant='info' center="true" animation='border' />}

                </Container>
            </>
        );
    }
console.log(subproducts2.length);
    if (subproducts2.length === 0) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl">
                   {/* <div style={{ display: 'flex', justifyContent: 'flex-start' }}> {menu_add===1 &&(<Link className="btn alink btncolorb" variant="btncolorb" to="/createSubProduct"><FaPlus className='fwcolor' /> Add Sub Product</Link>)}{' '}</div> */}
                </Container>
                <Container className="my-4 mx-4 container-xl">
                    {/* <h2   style={{marginLeft:'130px',marginRight:'-100px'}}>No Sub Product to display.....</h2> */}
                    <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%", marginTop:'-80px' }}>
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: 'rgb(0 0 0 / 3%)', padding: '10px' }}>

                                    {/* <Link to="/" style={{ marginLeft: '0px', marginRight: '-100px' }}>{menu_add===1 &&(<Link className="btn alink btncolorb" variant="btncolorb" to="/createSubProduct"><FaPlus className='fwcolor' /> Add Sub Product</Link>)}<br /><span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' }}><FaArrowLeft />&nbsp;Go Back</span></Link><h4>Subproduct List</h4> */}
                                    {menu_add === 1 && (<Button1 variant="contained" onClick={onPagepath} color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px' }} startIcon={<AddCircleOutlineIcon />}>
                                        Add Sub Product
                                    </Button1>)}<br />
                                    <Link to="/" style={{ marginLeft: '0px', marginRight: '-100px' }}> <span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' }}><FaArrowLeft />&nbsp;Go Back</span></Link><h4  style={{fontFamily:'Times New Roman' }}>Subproduct List</h4>

                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{textAlign:'center'}}>No Data Available.</td>
                               
                            </tr>


                        </tbody>
                    </table>
                </Container>
            </>
        );
    }


    const renderedSubProduct = subproducts2.filter(obj => obj.product_id == id).map((subproduct,index) => (
        
        <tr key={subproduct.id}>
            <td>{index + 1}</td>

            {/* <td>{subproduct.product_name}</td> */}
            <td>{subproduct.subproduct_name}</td>
              
            <td>{subproduct.status == 1 ? <span className="badge bg-success"> Enable</span> : <span className="badge bg-danger"> Disable</span>}</td>
            {name2 ?<><td><Tooltip title="View Rates" ><Button className="btn btn-sm btn" style={{backgroundColor:'black'}} onClick={(e) => onSubProductViewRates2(subproduct.id,subproduct.subproduct_name, e)} ><FaEye className='fwcolor' /></Button></Tooltip></td></>:
           <> <td className="tdstyle" style={{width:"214px"}}><> {menu_edit===1 &&(<Button className="btn btn-sm btn-warning"  onClick={(e) => onSubProductModify(subproduct.id,e)}  id={subproduct.id} ><FaEdit className='fwcolor' /></Button>)}&nbsp;
            {menu_delete===1 && (<Button className="btn btn-sm btn-danger"  onClick={(e) => onSubProductDelete(subproduct.id, e)} ><FaTrash className='fwcolor' /></Button>)}
            &nbsp;{menu_add===1 &&(<Tooltip title="Add More Rates" ><Button className="btn btn-sm btn-primary"  onClick={(e) => onSubProductAddMore(subproduct.id,subproduct.subproduct_name, e)} ><FaPlus className='fwcolor' /></Button></Tooltip>)}&nbsp;{menu_edit===1 &&(<Tooltip title="Modify Rates" ><Button className="btn btn-sm btn" style={{backgroundColor:'black'}} onClick={(e) => onSubProductViewRates(subproduct.id,subproduct.subproduct_name, e)} ><FaEdit className='fwcolor' /></Button></Tooltip>)}&nbsp;<Tooltip title="View All Rates" ><Button className="btn btn-sm btn" style={{backgroundColor:'purple'}} onClick={(e) => onSubProductViewAllRates(subproduct.id,subproduct.subproduct_name, e)} ><FaEye className='fwcolor' /></Button></Tooltip>&nbsp;<Tooltip title="View Itinerary Details" ><Button className="btn btn-sm btn" style={{backgroundColor:'green'}} onClick={(e) => onSubProductViewItenary(subproduct.id,subproduct.subproduct_name, e)} ><FaEye className='fwcolor' /></Button></Tooltip></></td>
            </> }
                   </tr>
    ))

    
    const onSubProductDelete = (idd, e) => {
        e.preventDefault();
        Swal.fire({
            title: 'Are you sure want to delete the sub product?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
                dispatch(subproductDeletion(idd)).then(() => {
                    dispatch(getAllMainSubProduct());
                    navigate(`/subproductListId/`+id+"/"+name);
                  Swal.fire(' Deleted Successfully!', '', 'success');
                })
            }
            // if (result.isConfirmed) {
            //     dispatch(subproductDeletion(idd));
            //     dispatch(getAllMainSubProduct());
            //     navigate(`/subproductListId/`+id);
            //     getAllMainSubProduct();
            //     setIsAlive(true)
                  
            //   Swal.fire('Sub Product Deleted Successfully!', '', 'success')
            // }
             else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })
 

    }

    const onSubProductModify = (idd, e) => {
        e.preventDefault();
       //console.log('select role '+id);
       navigate('/modifySubProduct/' + idd + "/" + id + "/" + name); 
   }


   const onSubProductAddMore = (id1,name1, e) => {
    e.preventDefault();
   //console.log('select role '+id);
   navigate('/rateaddmore/' + id1 + "/" +name1 + "/" + id + "/"+name); 
}

const onSubProductViewRates = (id1,name1, e) => {
    e.preventDefault();
   //console.log('select role '+id);
   navigate('/viewratespage/' + id1 + "/" + name1 + "/" + id + "/"+name); 
}



const onSubProductViewItenary = (id1,name1, e) => {
    e.preventDefault();
   //console.log('select role '+id);
   navigate('/viewitenarypage/' + id1 + "/" + name1 + "/" + id + "/"+name); 
}

const onSubProductViewAllRates = (id1,name1, e) => {
    e.preventDefault();
   //console.log('select role '+id);
   navigate('/viewratessingleview/' + id1 + "/" + name1 + "/" + id + "/"+name); 
}


const onSubProductViewRates2 = (id1,name1, e) => {
    e.preventDefault();
   //console.log('select role '+id);
   navigate('/viewratespage/' + id1 + "/" + name1 + "/" + id + "/"+name + "/" + "approval"); 
}


    //initialize datatable
    $(document).ready(function () {
        setTimeout(function () {
            if ($.fn.dataTable.isDataTable('#example')) {
                const table = $('#example').DataTable();
            }
            else {
                const table = $('#example').DataTable({
                    paging: true,
                    pagingType: 'full_numbers',
                    pageLength: 5,
                    processing: true,
                    dom: 'Bfrtip',
                    buttons: ['csv', 'print'],
                    // buttons: ['copy', 'csv', 'print'],
                    destroy: true,

                });
            }

        },
            1000
        );
    });
    return (
        <>

            <div className="my-4  container-xl">
                <div className="card"  style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman',fontWeight:'600' }}>Sub Product List</h3>
                        {/* <div style={{ display: 'flex', justifyContent: 'flex-start' }}>{menu_add===1 && !name2 ? <Link className="btn alink btncolorb" variant="btncolorb" to="/createSubProduct"><FaPlus className='fwcolor' /> Add Sub Product</Link>:''}{' '}</div> */}
               {menu_add===1 && !name2 ? <Button1 variant="contained" onClick={onPagepath} color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px'}} startIcon={<AddCircleOutlineIcon />}>
                        Add Sub Product
                        </Button1>:''}{' '}
               
               
               </div>
                        
                   
                    <div className="card-body">
                   {name2 ? <Link to="/subproductList/approval"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> : <Link to="/subproductList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link>} <center><span className="badge bg" style={{backgroundColor:'rgb(156 186 237)',color:'black'}}>Product Name: {name}</span></center>
                        {/* <Row>
                            <Col>
                            {pdmessage && (<Alert variant={pdstatus === "success" ? "success" : "danger"}>{pdmessage}</Alert>)}
                            </Col>
                        </Row> */}

                        {subproducts2?.length
                            ? (
                                <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                             {/* <th>Image</th> */}
                                            {/* <th>Product Name</th> */}
                                            <th>Sub Product Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderedSubProduct}


                                    </tbody>
                                </table>
                            ) : <p>No subproducts to display</p>
                        }

                    </div>
                </div>
            </div>

        </>
    )
}

export default SubProductListId
